import React, { Component } from "react";
import { toast, ToastContainer, cssTransition } from "mdbreact";
import "react-toastify/scss/main.scss";
import styles from "./style.module.scss";
import cx from "classnames";
import Parser from "html-react-parser";
import isHTML from "is-html";

export class ToastNotification extends Component {
  render() {
    return (
      <ToastContainer
        hideProgressBar
        newestOnTop
        autoClose={4000}
        toastClassName={styles.toast}
        bodyClassName={styles.toastBody}
        closeButton={false}
      />
    );
  }
}

export const openToast = (message, type = "") => {
  const content =
    typeof message === "string" && isHTML(message) ? Parser(message) : message;
  if (!type) {
    toast.info(content);
  } else if (type === "warning") {
    toast.warn(content);
  } else if (type === "error") {
    toast.error(content);
  } else if (type === "success") {
    toast.success(content);
  } else if (type === "modal") {
    toast(content, {
      position: "bottom-left",
      className: cx(styles.modal),
      closeOnClick: true,
      autoClose: 5000,
      transition: cssTransition({
        enter: "zoomIn",
        exit: "zoomOut",
        duration: 0
      })
    });
  }
};
